<template>
    <div class="student-info">
        <div class="flex ai-c jc-sb">
            <div class="flex ai-c col-2">
                <el-input v-model="query.condition.periodname" class="mr-10" size="medium" placeholder="课时名称" clearable></el-input>
                <el-select v-model="query.condition.status" size="medium" clearable placeholder="完课状态">
                    <el-option label="已完成" :value="30"></el-option>
                    <el-option label="未完成" :value="10"></el-option>
                </el-select>
                <div class="flex aic-c ml-10">
                    <el-button @click="() => getStudentStudyList(query)" type="primary" icon="el-icon-search" plain>搜索</el-button>
                    <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
                </div>
            </div>
            <el-button @click="exportStudentStudyList" type="primary" icon="el-icon-download" :disabled="!studentInfoList.length&&!className">导出</el-button>
        </div>
        <el-table :data="studentInfoList" v-loading="loading" border class="mt-20 table-fixed-col">
            <el-table-column label="序号" type="index" :index="indexFormatter" key="index" align="center" :width="getTableHeaderWidthByOrderCol()" fixed></el-table-column>
            <el-table-column label="课时名称" prop="periodname" key="periodname" align="center" fixed min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="昵称" key="nickname" align="center" fixed min-width="180" show-overflow-tooltip>
                <span slot-scope="{ row }">{{ `${row.nickname}(${row.studentno})` }}</span>
            </el-table-column>
            <el-table-column label="姓名" prop="studentname" key="studentname" align="center" fixed min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="性别" prop="sexname" key="sexname" align="center" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column label="所在校区" prop="campusname" key="campusname" align="center" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="学习进度" prop="studyrate" key="studyrate" align="center" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column label="累计时长" prop="totalstudytimes" key="totalstudytimes" align="center" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column label="完课状态" prop="isfinishstudy" key="isfinishstudy" align="center" min-width="80" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-pagination
            :hide-on-single-page="!total || total < 1"
            class="mt-20 flex ai-c jc-fd"
            @size-change="handePageSizeChange"
            @current-change="curPageChange"
            @prev-click="curPageChange"
            @next-click="curPageChange"
            layout="total, sizes, prev, pager, next"
            :total="total"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="20"
            :current-page.sync="queryCache.page"
            background
        ></el-pagination>
    </div>
</template>
<script>
import { getStudentStudyList, exportStudentStudyList } from '@/api/measApi/studyManagement'
import { deepClone } from '@/common/js/tools'
export default {
    data: () => ({
        total: 0,
        loading: false,
        studentInfoList: [],
        query: {
            condition: {
                periodname: '',
                classcoursecode: '',
                status: '',
            },
        },
        queryCache: {
            page: 1,
            pagesize: 20,
        },
    }),
    props: {
        // 班级code
        courseCode: {
            require: true,
            type: String,
        },
        classCode: {
            require: true,
            type: String,
        },
        code: {
            require: true,
            type: String,
        },
        courseName: {
            type: String,
            require: true,
        },
        className: {
            type: String,
            require: true,
        },
    },
    created() {
        Object.assign(this.queryCache, deepClone(this.query))
    },
    methods: {
        init() {
            this.getStudentStudyList()
        },
        reset() {
            this.query.condition.status = ''
            this.query.condition.periodname = ''
            this.getStudentStudyList(this.query)
        },
        // 获取学员学情列表
        async getStudentStudyList(param) {
            if (param) {
                this.queryCache.page = 1
            }
            Object.assign(this.queryCache, deepClone(param))
            this.queryCache.condition.classcoursecode = this.courseCode
            this.queryCache.condition.classcode = this.classCode
            this.queryCache.condition.periodcode = this.code
            this.loading = true
            try {
                const res = await getStudentStudyList(this.queryCache)
                if (res.code === '000') {
                    this.studentInfoList = res.data
                    this.total = res.pageinfo.rowcount
                }
                this.loading = false
            } catch {
                this.loading = false
            }
        },
        // 导出学员学情列表
        async exportStudentStudyList() {
            this.queryCache.condition.classcoursecode = this.courseCode
            await exportStudentStudyList(this.queryCache, `${this.className}(${this.courseName}).xlsx`)
        },
        // 序号格式化
        indexFormatter(index) {
            return index + 1 + (this.queryCache.page - 1) * this.queryCache.pagesize
        },
        // 分页大小改变
        handePageSizeChange(e) {
            this.queryCache.page = 1
            this.queryCache.pagesize = e
            this.getStudentStudyList()
        },
        // 页面跳转
        curPageChange(e) {
            this.queryCache.page = e
            this.getStudentStudyList()
        },
    },
}
</script>
<style lang="scss" scoped>
.student-info {
    padding: 2px;
    .el-button {
        margin-bottom: 0 !important;
    }
    ::v-deep .el-input,
    .el-select {
        height: 36px !important;

        > .el-input {
            height: 36px !important;
        }
    }
}
</style>
